import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "../App";

// No cross-session cache: every mounted platform surface confirms its own count.
export default function PendingApprovalLink({ onClick, className = "" }) {
  const [value, setValue] = useState("Loading…");
  useEffect(() => {
    let active = true;
    let generation = 0;
    const load = () => {
      const request = ++generation;
      setValue("Loading…");
      axios.get(`${API}/organizations/pending/count`).then(({ data }) => {
        if (active && request === generation) setValue(Number.isSafeInteger(data?.count) && data.count >= 0 ? data.count : "Unavailable");
      }).catch(() => { if (active && request === generation) setValue("Unavailable"); });
    };
    load();
    window.addEventListener("organization-approvals-changed", load);
    window.addEventListener("focus", load);
    return () => { active = false; window.removeEventListener("organization-approvals-changed", load); window.removeEventListener("focus", load); };
  }, []);
  return <Link className={className} onClick={onClick} to="/platform/organizations#pending-applications">Pending approvals: {value}</Link>;
}
